import { env } from './config.js'

export class LeadError extends Error {
  constructor(message, code = 'failed') { super(message); this.code = code }
}

export function collectContext() {
  const url = new URL(window.location.href)
  const utm = Object.fromEntries([...url.searchParams].filter(([key]) => key.startsWith('utm_')))
  const width = window.innerWidth
  return { sourceUrl: `${url.origin}${url.pathname}`, utm, referrer: document.referrer || '', deviceCategory: width < 768 ? 'mobile' : width < 1100 ? 'tablet' : 'desktop', browserLanguage: navigator.language }
}

export async function submitLead(payload) {
  if (!env.leadEndpoint) return { ok: true, demo: true }
  if (!env.leadEndpoint.startsWith('https://') && !env.leadEndpoint.startsWith('/')) throw new LeadError('Unsafe lead endpoint', 'configuration')
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), env.leadTimeout)
  try {
    const response = await fetch(env.leadEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: controller.signal })
    const result = await response.json().catch(() => ({}))
    if (!response.ok) throw new LeadError(`Lead endpoint returned ${response.status}`, result.error || 'failed')
    return { ...result, ok: true, demo: false }
  } catch (error) {
    if (error.name === 'AbortError') throw new LeadError('Lead request timed out', 'timeout')
    if (error instanceof LeadError) throw error
    throw new LeadError('Lead submission failed')
  } finally { clearTimeout(timer) }
}

export async function verifyTurnstile(token, submissionKey) {
  if (!env.turnstileEndpoint) throw new LeadError('Turnstile endpoint is not configured', 'turnstile')
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), env.leadTimeout)
  try {
    const response = await fetch(env.turnstileEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, submissionKey }),
      signal: controller.signal,
    })
    const result = await response.json().catch(() => ({}))
    if (!response.ok || result.success !== true) throw new LeadError('Turnstile verification failed', 'turnstile')
    return result
  } catch (error) {
    if (error.name === 'AbortError') throw new LeadError('Turnstile verification timed out', 'turnstile')
    if (error instanceof LeadError) throw error
    throw new LeadError('Turnstile verification failed', 'turnstile')
  } finally { clearTimeout(timer) }
}
